<template>
    <div v-if="report.summary != null && report.summary.length > 0" class="row">
        <div class="col-12">
            <div class="card">
                <div v-if="report.summary != null" class="card-content">
                    <div class="row">
                        <div class="col-xl-4 col-md-4 col-12 mx-auto">
                            <credit-scores :client-email="email" />
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table v-if="report.summary.length > 0" class="table table-success table-hover table-striped mb-0">
                            <thead class="thead-primary">
                                <tr>
                                    <th style="width:200px"></th>
                                    <th style="width:200px">
                                        <!-- TransUnion -->
                                        <img :src="reportStore.images.transunion" alt="image" width="75" height="75" class="d-block">
                                    </th>
                                    <th style="width:200px">
                                        <!-- Experian -->
                                        <img :src="reportStore.images.experian" alt="image" width="75" height="75" class="d-block">
                                    </th>
                                    <th style="width:200px">
                                        <!-- Equifax -->
                                        <img :src="reportStore.images.equifax" alt="image" width="75" height="75" class="d-block">
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="table-striped">
                                <tr>
                                    <td>{{ localizationStore.translate("credit.summary.table.row.one") }}</td>
                                    <td v-html="getSummaryDifference('TransUnion', 'total_accounts')"></td>
                                    <td v-html="getSummaryDifference('Experian', 'total_accounts')"></td>
                                    <td v-html="getSummaryDifference('Equifax', 'total_accounts')"></td>
                                </tr>
                                <tr>
                                    <td>{{ localizationStore.translate("credit.summary.table.row.two") }}</td>
                                    <td v-html="getSummaryDifference('TransUnion', 'open_accounts')"></td>
                                    <td v-html="getSummaryDifference('Experian', 'open_accounts')"></td>
                                    <td v-html="getSummaryDifference('Equifax', 'open_accounts')"></td>
                                </tr>
                                <tr>
                                    <td>{{ localizationStore.translate("credit.summary.table.row.three") }}</td>
                                    <td v-html="getSummaryDifference('TransUnion', 'closed_accounts')"></td>
                                    <td v-html="getSummaryDifference('Experian', 'closed_accounts')"></td>
                                    <td v-html="getSummaryDifference('Equifax', 'closed_accounts')"></td>
                                </tr>
                                <tr>
                                    <td>{{ localizationStore.translate("credit.summary.table.row.four") }}</td>
                                    <td v-html="getSummaryDifference('TransUnion', 'collection')"></td>
                                    <td v-html="getSummaryDifference('Experian', 'collection')"></td>
                                    <td v-html="getSummaryDifference('Equifax', 'collection')"></td>
                                </tr>
                                <tr>
                                    <td>{{ localizationStore.translate("credit.summary.table.row.five") }}</td>
                                    <td v-html="getSummaryDifference('TransUnion', 'delinquent')"></td>
                                    <td v-html="getSummaryDifference('Experian', 'delinquent')"></td>
                                    <td v-html="getSummaryDifference('Equifax', 'delinquent')"></td>
                                </tr>
                                <tr>
                                    <td>{{ localizationStore.translate("credit.summary.table.row.six") }}</td>
                                    <td v-html="getSummaryDifference('TransUnion', 'derogatory')"></td>
                                    <td v-html="getSummaryDifference('Experian', 'derogatory')"></td>
                                    <td v-html="getSummaryDifference('Equifax', 'derogatory')"></td>
                                </tr>
                                <tr>
                                    <td>{{ localizationStore.translate("credit.summary.table.row.seven") }}</td>
                                    <td v-html="getSummaryDifference('TransUnion', 'balances')"></td>
                                    <td v-html="getSummaryDifference('Experian', 'balances')"></td>
                                    <td v-html="getSummaryDifference('Equifax', 'balances')"></td>
                                </tr>
                                <tr>
                                    <td>{{ localizationStore.translate("credit.summary.table.row.eigth") }}</td>
                                    <td v-html="getSummaryDifference('TransUnion', 'payments')"></td>
                                    <td v-html="getSummaryDifference('Experian', 'payments')"></td>
                                    <td v-html="getSummaryDifference('Equifax', 'payments')"></td>
                                </tr>
                                <tr>
                                    <td>{{ localizationStore.translate("credit.summary.table.row.nine") }}</td>
                                    <td v-html="getSummaryDifference('TransUnion', 'public_records')"></td>
                                    <td v-html="getSummaryDifference('Experian', 'public_records')"></td>
                                    <td v-html="getSummaryDifference('Equifax', 'public_records')"></td>
                                </tr>
                                <tr>
                                    <td>{{ localizationStore.translate("credit.summary.table.row.ten") }}</td>
                                    <td v-html="getSummaryDifference('TransUnion', 'inquiries')"></td>
                                    <td v-html="getSummaryDifference('Experian', 'inquiries')"></td>
                                    <td v-html="getSummaryDifference('Equifax', 'inquiries')"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="!reportStore.reports[email].haveReport">
        <div class="col-sm-12">
            <div class="card" :class="{ 'shadow': $route.params.client }" >
                <div class="card-body">
                    <div class="mx-auto">
                        <h3 class="text-center text-warning mb-1">Oops...Your Credit Report is Missing.</h3>
                        <h6 class=" text-center text-warning mb-2">In order view the Dispute Center, you must import your Credit Report.
                            <br> If you don't already have a credit report, you can get one by clicking the button below.
                        </h6>
                    </div>
                    <div style="text-align:center;">
                        <a href="https://www.smartcredit.com/?PID=54821" target="_blank" type="submit"
                            class="btn btn-warning ">
                            <i data-feather="external-link" class="mr-25"></i> <span>SmartCredit</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <p v-else class="text-center font-medium-3 text-bold-600 warning"> You don't have any Report Data.</p>
</template>

<script>
    import { reactive, computed } from 'vue'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { isNumeric, parse, parser, number, format, hasNumericValue } from 'mathjs'
    export default {
        mounted() {
        },
        props: {
            email: String
        },
        setup(props) {
            return {
                localizationStore: useLocalizationStore(),
                reportStore: useReportStore(),
                report: useReportStore().reports[props.email].report,
                previousReport: useReportStore().reports[props.email].previousReport,
            }
        },
        computed: {
            
        },
        methods: {
            getSummaryDifference (creditReportingAgency, column) {
                if (this.reportStore.reports[this.email] && this.reportStore.reports[this.email].haveOldReport) {
                    let difference = 0, reportData = this.report.summary.find((reportSummary) => {
                        if (reportSummary.credit_reporting_agency.name == creditReportingAgency) {
                            return reportSummary;
                        }
                    });
                    let previousReportData = this.previousReport.summary.find((reportSummary) => {
                        if (reportSummary.credit_reporting_agency.name == creditReportingAgency) {
                            return reportSummary;
                        }
                    });
                    if (column == "balances" || column == "payments") {
                        var reportBalance = reportData[column].replaceAll("$", '');
                        reportBalance = reportBalance.replaceAll(",", '');
                        var previousReportBalance = previousReportData[column].replaceAll("$", '');
                        previousReportBalance = previousReportBalance.replaceAll(",", '');
                        difference = number(reportBalance) - number(previousReportBalance);
                    }
                    else if(hasNumericValue(reportData[column]) && hasNumericValue(previousReportData[column])) {
                        difference = number(reportData[column]) - number(previousReportData[column]);
                    }
                    // console.log(isNumeric(reportData[column]));
                    if (difference > 0) {
                        let differenceDisplay = null;
                        if (column == "balances" || column == "payments") {
                            differenceDisplay = format(difference, (value) => { return '$' + value.toFixed(2) }) + " Increase";
                        }
                        else {
                            differenceDisplay = difference + " Added";
                        }
                        return `
                            <span>
                                ${this.getSummary(creditReportingAgency, 'report')[column]}
                            </span>
                            <sub class="text-success">
                                +${differenceDisplay}
                            </sub>
                        `;
                    }
                    else if(difference < 0) {
                        let differenceDisplay = null;
                        if (column == "balances" || column == "payments") {
                            differenceDisplay = format(difference, (value) => { return '$' + value.toFixed(2) }) + " Decrease";
                        }
                        else {
                            differenceDisplay = difference + " Updated";
                        }
                        return `
                            <span>
                                ${this.getSummary(creditReportingAgency, 'report')[column]}
                            </span>
                            <sub class="text-danger">
                                ${differenceDisplay}
                            </sub>
                        `;
                    }
                }
                return `
                    <span>
                        ${this.getSummary(creditReportingAgency, 'report')[column]}
                    </span>
                `;
            },
            getSummary(creditReportingAgency, reportType) {
                return this[reportType].summary.find((reportSummary) => {
                    if (reportSummary.credit_reporting_agency.name == creditReportingAgency) {
                        return reportSummary;
                    }
                })
            },
        }
    }
</script>
